import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import axios from "axios";
import { showToast } from "../../../components/common/notification/Notification";
import PostDetailCard from "./PostDetailCard";

const PostDetail = ({ back = "/partner/posts", ownerId: setOwnerId }) => {
  const { Id } = useParams();
  const [postData, setPostData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isError, setIsError] = useState(false);

  const loggedInUser = useSelector((state) => state.auth?.user);
  const token =
    loggedInUser?.accessToken ||
    loggedInUser?.token ||
    loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const assetUrl = process.env.REACT_APP_ASSET_URL || baseUrl || "";

  const [mediaData, setMediaData] = useState({
    images: [],
    videos: [],
    attachments: [],
  });

  useEffect(() => {
    if (Id) {
      fetchPostItem();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Id]);

  const fetchPostItem = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${baseUrl}/property/lead/${Id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const post = response.data.lead || response.data.data || response.data;
        const owner =
          post.user?.id ||
          post.customer?.id ||
          post.partner?.id ||
          post.user_id;

        if (setOwnerId && owner) {
          setOwnerId(owner);
        }

        const rawFirstName =
          post.customer?.first_name ||
          post.partner?.first_name ||
          post.user?.first_name;
        const rawLastName =
          post.customer?.last_name ||
          post.partner?.last_name ||
          post.user?.last_name;
        let cleanName = [rawFirstName, rawLastName].filter(Boolean).join(" ");

        if (!cleanName || cleanName.toLowerCase().includes("null")) {
          cleanName =
            post.customer_name &&
            !post.customer_name.toLowerCase().includes("null")
              ? post.customer_name
              : post.user?.name ||
                (post.user?.email_address
                  ? post.user.email_address.split("@")[0]
                  : null) ||
                (post.customer?.email_address
                  ? post.customer.email_address.split("@")[0]
                  : null) ||
                "Community Member";
        }

        if (cleanName && typeof cleanName === "string") {
          cleanName = cleanName.charAt(0).toUpperCase() + cleanName.slice(1);
        }

        const propertyTypeName =
          typeof post.property_type === "object"
            ? post.property_type?.name
            : post.property_type || null;

        const resolvedImages = (post.images || []).map((img) => ({
          url: (img.image_url || img.imagePath || img.url || "").startsWith("http")
            ? img.image_url || img.imagePath || img.url
            : `${assetUrl.replace(/\/+$/, "")}/${(
                img.image_url ||
                img.imagePath ||
                img.url ||
                ""
              ).replace(/^\/+/, "")}`,
        }));

        const resolvedVideos = (post.videos || []).map((video) => ({
          url: (video.url_path || video.url || "").startsWith("http")
            ? video.url_path || video.url
            : `${assetUrl.replace(/\/+$/, "")}/${(
                video.url_path ||
                video.url ||
                ""
              ).replace(/^\/+/, "")}`,
        }));

        const rawAttachments =
          post.attachements || post.attachments || [];
        const resolvedAttachments = rawAttachments.map((attachment) => ({
          name: attachment.name || "Attachment Document",
          attachment_url: (
            attachment.attachment_url ||
            attachment.url ||
            attachment.url_path ||
            ""
          ).startsWith("http")
            ? attachment.attachment_url ||
              attachment.url ||
              attachment.url_path
            : `${assetUrl.replace(/\/+$/, "")}/${(
                attachment.attachment_url ||
                attachment.url ||
                attachment.url_path ||
                ""
              ).replace(/^\/+/, "")}`,
        }));

        setPostData({
          postId: post.id || Id,
          ownerId: owner,
          creatorName: cleanName,
          city: post.city_name,
          state: post.state_name,
          country: post.country_name,
          areaName: post.area_name,
          budget: post.budget,
          propertyType: propertyTypeName,
          description: post.description,
          createdOn: post.created_on || post.created_at,
          photo: post.customer?.photo || post.partner?.photo || post.user?.photo || post.photo,
          service: post.service,
          mobileNumber:
            post.customer?.mobile_number ||
            post.partner?.mobile_number ||
            post.user?.mobile_number ||
            post.mobile_number,
          emailAddress:
            post.customer?.email_address ||
            post.partner?.email_address ||
            post.user?.email_address ||
            post.email_address,
          userType:
            post.user?.userType?.name ||
            post.customer?.userType?.name ||
            post.partner?.userType?.name ||
            (post.partner ? "Property Partner" : "Customer"),
        });

        setMediaData({
          images: resolvedImages,
          videos: resolvedVideos,
          attachments: resolvedAttachments,
        });
      } else {
        showToast("Failed to fetch post data", { type: "error" });
      }
    } catch (error) {
      setIsError(true);
      console.error("Fetch error:", error);
      showToast("Error fetching post data", { type: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  // Determine back path & discussion path
  const normalizedBack = back.replace(/\/+$/, "");
  const discussionPath = `${normalizedBack}/${Id}/discussion`;

  if (isLoading) {
    return (
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "16px" }}>
        <div
          style={{
            height: "44px",
            background: "#f1f5f9",
            borderRadius: "8px",
            marginBottom: "20px",
            width: "300px",
          }}
        />
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1.55fr 1fr",
            gap: "24px",
          }}
        >
          <div
            style={{
              height: "480px",
              background: "#ffffff",
              borderRadius: "12px",
              border: "1px solid #e2e8f0",
              padding: "24px",
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <div
              style={{
                height: "260px",
                width: "100%",
                background: "#f1f5f9",
                borderRadius: "10px",
              }}
            />
            <div
              style={{
                height: "32px",
                width: "60%",
                background: "#f1f5f9",
                borderRadius: "6px",
              }}
            />
            <div
              style={{
                height: "80px",
                width: "100%",
                background: "#f1f5f9",
                borderRadius: "6px",
              }}
            />
          </div>
          <div
            style={{
              height: "280px",
              background: "#ffffff",
              borderRadius: "12px",
              border: "1px solid #e2e8f0",
              padding: "20px",
            }}
          />
        </div>
      </div>
    );
  }

  if (!postData) {
    return null;
  }

  return (
    <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "8px 16px 24px" }}>
      <PostDetailCard
        postId={postData.postId}
        creatorName={postData.creatorName}
        description={postData.description}
        createdOn={postData.createdOn}
        state={postData.state}
        city={postData.city}
        areaName={postData.areaName}
        budget={postData.budget}
        propertyType={postData.propertyType}
        images={mediaData.images}
        videos={mediaData.videos}
        attachments={mediaData.attachments}
        service={postData.service}
        photo={postData.photo}
        mobileNumber={postData.mobileNumber}
        emailAddress={postData.emailAddress}
        userType={postData.userType}
        back={back}
        discussionPath={discussionPath}
      />
    </div>
  );
};

export default PostDetail;